module.exports = __webpack_public_path__ + "static/Analisis-d37af9e0bdf66765f61e7fb8ebd5e50c.png";